import {getElementsRegExp} from "../data/getElementsRegExp";
export const handleArtifacts = (res) => {
    /* Elements */
    const elementRegEx = getElementsRegExp();
    /* Button */
    const buttonValueRegEx = /(({(button) value=\"([a-zA-Z0-9À-ÿ .\[\]^*\/'ç?¿\-+,#\n·¡!$%&()=@]*)\"*})([\w\W\s][^{/]*[^{/]*)({\/button})*)/gm;

    var existElements = false,
        res_elements = [];

    var array_elements = [],
        get_elements = [...res?.matchAll(elementRegEx)];

    var text = "";

    get_elements.forEach(element => {
        var ele = element[0];
        if (ele) {
            text = ele;
            var match_button = [...ele.matchAll(buttonValueRegEx)];

            if (match_button && match_button.length === 1) {
                existElements = true;
                array_elements.push({
                    id: array_elements.length + 1,
                    element: match_button[0][3],
                    value: match_button[0][4],
                    value_save: match_button[0][4],
                    text: match_button[0][5],
                    text_save: match_button[0][5]
                });
            } else {
                array_elements.push({element: 'text', text: ele, text_save: ele});
            }
        }

    });

    if (array_elements.length > 0) {
        res_elements.push(array_elements);
    }

    if (res_elements.length > 0 && existElements) {
        return res_elements;
    }

    if (text) {
        return [[{element: "text", text: text, text_save: text}]]
    }

    return false;
}